import React from 'react';

export const SafetyDiariesPrintOut = ({
  onPrintSeparted,
  onPrintPortrait,
  onPrintLandscape,
  onClose,
}) => (
  <div
    className='dialog-md dialog--modal'
    onClick={e => {
      e.stopPropagation();
    }}
  >
    <div className='dialog-md__header'>
      <span className='dialog-md__title'>帳票の形式を選択</span>
    </div>
    <div className='dialog-md__body'>
      <div>
        <button
          className='btn-fixedsize'
          onClick={() => {
            onPrintSeparted();
          }}
        >
          上写真・下情報(A4縦)
        </button>
      </div>
      <div>
        <button
          className='btn-fixedsize'
          onClick={() => {
            onPrintPortrait();
          }}
        >
          3枚割り付け(A4縦)
        </button>
      </div>
      <div>
        <button
          className='btn-fixedsize'
          onClick={() => {
            onPrintLandscape();
          }}
        >
          3枚割り付け(A4横)
        </button>
      </div>
    </div>
    <div className='dialog-md__footer'>
      <button
        className='btn-fixedsize--sub'
        onClick={() => {
          onClose();
        }}
      >
        戻る
      </button>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/modals/SafetyDiariesPrintOut.jsx